import React, { useCallback } from 'react';
import { loadNotepad, saveNotepad } from '../api/Api';

export function NotepadPanel(props) {

	const [notepadText, setNotepadText] = React.useState("");

	const [disableScroll, setDisableScroll] = React.useState(false);
	
	const [scrollTop, setScrollTop] = React.useState(0);


	function handleChange(event) {
		props.setFormStatus({ message: "Modified" });
		setDisableScroll(true);
		setNotepadText(event.target.value);
	}

	function save() {
		saveNotepad(notepadText, props.setFormStatus)
	}

	function scroll(event) {
		
		if(disableScroll) {
			//console.log("Scroll Stopped");			
			event.target.scrollTop = scrollTop;
			setDisableScroll(false);
		} else {
			setScrollTop(event.target.scrollTop);
		}
	}

	const load = useCallback(() => {
		loadNotepad(setNotepadText, props.setFormStatus)
	}, [props.setFormStatus]);

	React.useEffect(() => {
		load()
	}, [load]);

	/* Prevent tab from moving out
	const textarea = document.querySelector('textarea')
	textarea.addEventListener('keydown', (e) => {
		if (e.keyCode === 9) {
			e.preventDefault()
		}
	}); */
	
	return (
		<div className="notepad-panel">
			<div className="notepad-buttons" >
				<button onClick={save}>Save</button>
				<button onClick={load}>Load</button>
			</div>
			<div className="notepad" >
				<textarea id="notepadta" value={notepadText} onChange={handleChange} onScroll={scroll}/>
			</div>
		</div>
	);
}
